import type { VerifyPassBannerSchema } from '@ecomm/home-landing-data'

export const verifyPassBannerMock: VerifyPassBannerSchema = {
  __typename: 'ContentfulHeroBanner',
  content: [
    {
      __typename: 'ContentfulHeroBannerColumn',
      description: {
        raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"We’re committed to\\nprotecting our\\nprotectors","nodeType":"text"}],"nodeType":"heading-2"},{"data":{"target":{"sys":{"id":"3X1SFysoxe0Kup9f5qhDKn","type":"Link","linkType":"Entry"}}},"content":[],"nodeType":"embedded-entry-block"},{"data":{},"content":[{"data":{},"marks":[],"value":"","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}',
        references: [
          {
            __typename: 'ContentfulFormV2',
            contentful_id: '3X1SFysoxe0Kup9f5qhDKn',
            form: [
              {
                title: 'I am a...',
                inputName: '',
                options: [
                  'Member of Military & Armed Forces',
                  'Medical Professionals',
                  'Teachers & Educators',
                  'First Responders'
                ]
              }
            ],
            button: {
              text: 'Receive 50% Off'
            }
          }
        ]
      },
      descriptionMobile: {
        raw: '{"data":{},"content":[{"data":{},"content":[{"data":{},"marks":[],"value":"We’re committed to\\nprotecting our\\nprotectors","nodeType":"text"}],"nodeType":"heading-2"},{"data":{"target":{"sys":{"id":"3X1SFysoxe0Kup9f5qhDKn","type":"Link","linkType":"Entry"}}},"content":[],"nodeType":"embedded-entry-block"},{"data":{},"content":[{"data":{},"marks":[],"value":"","nodeType":"text"}],"nodeType":"paragraph"}],"nodeType":"document"}',
        references: [
          {
            __typename: 'ContentfulFormV2',
            contentful_id: '3X1SFysoxe0Kup9f5qhDKn',
            form: [
              {
                title: 'I am a...',
                inputName: '',
                options: [
                  'Member of Military & Armed Forces',
                  'Medical Professionals',
                  'Teachers & Educators',
                  'First Responders'
                ]
              }
            ],
            button: {
              text: 'Receive 50% Off'
            }
          }
        ]
      },
      image: {
        title: 'First Responder Hero',
        description: 'some image description',
        file: {
          url: '//images.ctfassets.net/v6awd0kabi65/5vskiLTQKrWYM2cve00pkd/22b2a4f3166ee8854b4af5351dda141b/hero_first-responder_3x.jpg',
          details: {
            size: 3892930,
            image: {
              width: 3936,
              height: 1800
            }
          }
        }
      }
    }
  ]
}
